import { InfoRounded } from '@mui/icons-material';
import './styles.scss';

import { Text, Button } from "@fragments";

/**
 * Inline informational callout with an optional CTA. The CTA takes either a
 * plain `ctaUrl` or an `onCtaClick` handler (SPA navigation, closing a modal…).
 */
export default function InfoBlock({ title, description, ctaText, ctaUrl, onCtaClick, className = '', ...props }) {
    const hasCta = !!ctaText && (!!ctaUrl || !!onCtaClick);

    return (
        <div {...props} className={`info-block-container ${className}`.trim()}>
            <div className="info-block-header">
                <Text.h4
                    left={<InfoRounded className='csf-6' />}
                    weight={400}
                    className="csf-6">
                    {title}
                </Text.h4>
                <Text.span className="csf-6 subtitle">
                    {description}
                </Text.span>
            </div>
            {
                hasCta && (
                    <Button
                        text={ctaText}
                        href={ctaUrl}
                        onClick={onCtaClick}
                        color="overlay"
                        size="small"
                        preventLoading
                    />
                )
            }
        </div>
    );
}
